module.exports = __webpack_public_path__ + "img/establishment-closed.f209fbe4.svg";